/*eslint-disable*/
import { yearDropDown } from '@/Helpers';
import moment from 'moment';

export const modes = {
	order: {
		heading: 'Multiple Orders',
		initialState: {
			fromStore: null,
			orderType: 'CMS',
			internalProcess: null,
			internalShift: null,
			expectedDeliveryDate: new Date(),
			date: moment(new Date()).format('DD-MM-YYYY'),
		},
		fields: [
			{
				id: 'fromStore',
				label: 'Purchase From Store',
				type: 'select',
				required: true,
				dataKey: 'storeList',
				groupBy: 'type',
			},
			{
				id: 'orderType',
				label: 'Order Type',
				type: 'tabs',
				required: true,
				configOptions: 'internalPOTypes',
			},
			{
				id: 'internalProcess',
				label: 'Select Process',
				type: 'select',
				required: false,
				dataKey: 'processList',
				enableField: ['fromStore'],
				dependsOn: [{ orderType: 'cms' }],
			},
			{
				id: 'internalShift',
				label: 'Available shift',
				extraInfo: 'SHIFT_TIME',
				noExpired: true,
				type: 'select',
				required: true,
				dataKey: 'shiftList',
				enableField: ['internalProcess'],
				dependsOn: [{ orderType: 'cms' }],
			},
			{
				id: 'date',
				label: 'Order Date',
				type: 'display',
				required: true,
			},
			{
				id: 'expectedDeliveryDate',
				label: 'Expected Delivery Date',
				type: 'date',
				required: true,
				shouldDisableDate: true,
			},
		],
		tableApiFetch: {
			header: 'storeList',
			row: 'fetchItems',
		},
		functionality: ['addProducts', 'paste'],
		tableTriggers: {
			header: ['fromStore'],
			row: ['expectedDeliveryDate'],
			rowRequiredFields: [
				'fromStore',
				'internalShift',
				'expectedDeliveryDate',
			],
		},
		buttons: [
			{
				id: 'multipleOrder',
				label: 'Multiple Sales Order',
				type: 'primary',
				style: 'flex-1 bg-amber-300',
			},
			{
				id: 'generateProductionPlan',
				label: 'Multiple Sales Order and Preview Production Plan',
				type: 'secondary',
				style: 'flex-1 hover:bg-amber-300 bg-amber-300',
			},
		],
		tableCellKey: 'order',
	},
	orderWise: {
		heading: 'Order Wise PO',
		initialState: {
			fromStore: null,
			orderType: 'CMS',
			internalProcess: null,
			internalShift: null,
			expectedDeliveryDate: new Date(),
			date: moment(new Date()).format('DD-MM-YYYY'),
		},
		fields: [
			{
				id: 'fromStore',
				label: 'Purchase From Store',
				type: 'select',
				required: true,
				dataKey: 'storeList',
				groupBy: 'type',
			},
			{
				id: 'orderType',
				label: 'Order Type',
				type: 'tabs',
				required: true,
				configOptions: 'internalPOTypes',
			},
			{
				id: 'internalProcess',
				label: 'Select Process',
				type: 'select',
				required: true,
				dataKey: 'processList',
				enableField: ['fromStore'],
				dependsOn: [{ orderType: 'cms' }],
			},
			{
				id: 'internalShift',
				label: 'Available shift',
				extraInfo: 'SHIFT_TIME',
				noExpired: true,
				type: 'select',
				required: true,
				dataKey: 'shiftList',
				enableField: ['internalProcess'],
				dependsOn: [{ orderType: 'cms' }],
			},
			{
				id: 'date',
				label: 'Order Date',
				type: 'display',
				required: true,
			},
			{
				id: 'expectedDeliveryDate',
				label: 'Expected Delivery Date',
				type: 'date',
				required: true,
				shouldDisableDate: true,
			},
		],
		tableApiFetch: {
			header: 'orderList',
			row: 'fetchOrderWiseItems',
		},
		functionality: ['addProducts', 'paste'],
		tableTriggers: {
			header: ['fromStore', 'expectedDeliveryDate', 'orderType'],
			row: ['expectedDeliveryDate', 'fromStore', 'orderType'],
			rowRequiredFields: ['fromStore', 'expectedDeliveryDate', 'orderType'],
		},
		buttons: [
			{
				id: 'multipleOrder',
				label: 'Multiple Sales Order',
				type: 'primary',
				style: 'flex-1 bg-amber-300',
			},
			{
				id: 'generateProductionPlan',
				label: 'Multiple Sales Order and Preview Production Plan',
				type: 'secondary',
				style: 'flex-1 hover:bg-amber-300 bg-amber-300',
			},
		],
		tableCellKey: 'orderWise',
	},
	dataEntry: {
		heading: 'Production Data Entry',
		initialState: {
			fromStore: null,
			internalProcess: null,
			orderType: 'CMS',
			internalShift: null,
			poCreationDate: new Date(),
			date: moment(new Date()).format('DD-MM-YYYY'),
		},
		fields: [
			{
				id: 'fromStore',
				label: 'Purchase From Store',
				type: 'select',
				required: true,
				dataKey: 'storeList',
				groupBy: 'type',
			},
			{
				id: 'orderType',
				label: 'Order Type',
				type: 'tabs',
				required: true,
				configOptions: 'internalPOTypes',
			},
			{
				id: 'internalProcess',
				label: 'Select Process',
				type: 'select',
				required: true,
				dataKey: 'processList',
				enableField: ['fromStore'],
				dependsOn: [{ orderType: 'cms' }],
			},
			{
				id: 'internalShift',
				label: 'Available shift',
				extraInfo: 'SHIFT_TIME',
				noExpired: true,
				type: 'select',
				required: true,
				dataKey: 'shiftList',
				enableField: ['internalProcess'],
				dependsOn: [{ orderType: 'cms' }],
			},
			{
				id: 'poCreationDate',
				label: 'PO Scheduled Date',
				type: 'date',
				required: true,
			},
		],
		tableApiFetch: {
			header: 'storeList',
			row: 'fetchPos',
		},
		tableTriggers: {
			header: ['fromStore'],
			row: ['poCreationDate'],
			rowRequiredFields: ['fromStore', 'internalShift', 'poCreationDate'],
		},
		functionality: ['addProducts', 'paste'],
		buttons: [
			{
				id: 'saveProductionData',
				label: 'Save',
				type: 'primary',
				style: 'flex-1 bg-amber-300',
				noDefineLabel: true,
			},
		],
		tableCellKey: 'dataEntry',
		tableConfig: {
			columnWidth: 150,
		},
	},
	longTermProduction: {
		heading: 'Long Term Production Plan',
		layoutConfig: {
			containerClass:
				'flex flex-row flex-nowrap items-center justify-start gap-x-4 py-3 px-4 w-full bg-white transition-all overflow-x-auto',
			fieldWrapperClass:
				'flex flex-row items-center gap-2 flex-1 min-w-0 mx-1',
			labelClass:
				'text-[12px] font-medium text-gray-700 whitespace-nowrap m-0 p-0',
			inputClass:
				'flex-1 [&_.rs-picker-toggle]:h-8 [&_.rs-picker-toggle]:py-1 [&_.rs-picker-toggle]:text-[13px] [&_input]:h-8 [&_input]:py-1 [&_input]:text-[13px]',
			tabContainerClass: 'flex bg-gray-100 rounded-md p-0.5',
			selectedTabClass:
				'px-4 py-1 text-[12px] font-medium h-7 rounded-md bg-white text-gray-800 font-semibold shadow-sm',
			unselectedTabClass:
				'px-4 py-1 text-[12px] font-medium h-7 rounded-md bg-transparent text-gray-500 hover:text-gray-700',
		},
		tableDataStatic: true,
		tableRenderKey: 'longTermProduction',
		initialState: {
			planName: `Plan ${moment().format('MMMM YYYY')}`,
			kitchen: null,
			planLength: 'Monthly',
			planPeriod: null,
			shift: null,
			currentStep: 1,
		},
		hideComp: ['legend'],
		functionality: ['search'],
		searchColumn: 'productName',
		fields: [
			{
				id: 'planName',
				label: 'Plan Name',
				type: 'text',
				required: true,
				placeholder: 'Enter Name',
				wrapperClass: 'flex-none w-auto',
				inputClass: 'w-[150px]',
			},
			{
				id: 'kitchen',
				label: 'Select Kitchen',
				type: 'select',
				required: true,
				dataKey: 'kitchenList',
				cleanable: false,
				placeholder: 'Select',
			},
			{
				id: 'planLength',
				label: 'Plan Length',
				type: 'tabs',
				required: true,
				tabOptions: ['Monthly', 'Weekly'],
				disabled: true,
			},
			{
				id: 'planPeriod',
				label: 'Plan Period',
				type: 'select',
				required: true,
				dataKey: 'periodList',
				cleanable: false,
				placeholder: 'Select Month',
				list: yearDropDown(),
			},
			{
				id: 'shift',
				label: 'Shift',
				type: 'select',
				required: true,
				dataKey: 'shiftList',
				cleanable: false,
				placeholder: 'Select Shift',
			},
			{
				id: 'refersh',
				label: '',
				type: 'button',
				buttonIcon: 'refresh',
				buttonText: '',
				buttonClass: 'p-1.5 rounded-md hover:bg-gray-100 cursor-pointer transition-colors border border-gray-200 shadow-sm active:scale-95 text-teal-600',
				wrapperClass: 'flex-none w-auto self-center',
				hideInEditMode: true,
			},
			{
				id: 'pasteExcel',
				label: '',
				type: 'button',
				buttonText: 'Paste Excel',
				buttonIcon: 'paste',
				buttonClass: 'bg-teal-600 hover:bg-teal-700 text-white px-4 py-1.5 rounded-md text-[13px] font-semibold h-8',
				wrapperClass: 'ml-auto flex-none self-center',
				enableField: ['kitchen', 'planPeriod'],
				disabled: false,
				hideInEditMode: true,
			},
			{
				id: 'addProducts',
				label: '',
				type: 'button',
				buttonText: 'Add Products',
				buttonIcon: 'plus',
				buttonClass: 'border border-gray-400 text-gray-600 hover:bg-gray-50 px-4 py-1.5 rounded-md text-[13px] font-semibold h-8',
				wrapperClass: 'ml-auto flex-none self-center',
				alwaysEnabled: true,
				showOnlyInEditMode: true,
			},
		],
		tableColumns: [
			{ name: 'S.No', id: 'S.No' },
			{ name: 'Product Name', id: 'productName' },
			{ name: 'Client Variant Id', id: 'clientVariantId' },
			{ name: 'Batch', id: 'batch' },
			{ name: 'Quantity For Production', id: 'quantity' },
			{ name: 'Remove', id: 'remove' },
		],
		buttons: [
			{
				id: 'previousStep',
				label: 'Previous Step',
				type: 'outline',
				style: 'border-gray-400 text-gray-600 hover:bg-gray-100',
				noDefineLabel: true,
				icon: 'arrowLeft',
				position: 'left',
				show: 1,
			},
			{
				id: 'reset',
				label: 'Reset',
				type: 'outline',
				style: 'border-gray-400 text-gray-600 hover:bg-gray-100',
				noDefineLabel: true,
				icon: 'reset',
				position: 'right',
			},
			{
				id: 'nextStep',
				label: 'Next Step',
				type: 'primary',
				style: 'bg-yellow-500 hover:bg-yellow-600',
				noDefineLabel: true,
				icon: 'check',
				position: 'right',
			},
		],
		editModeButtons: [
			{
				id: 'longTermRecalculate',
				label: 'Adjust Variance for Remaining Days',
				type: 'outline',
				style: 'border-gray-400 text-gray-600 hover:bg-gray-100 flex-1',
				noDefineLabel: true,
				icon: 'refresh',
				position: 'left',
			},
			{
				id: 'longTermEditSave',
				label: 'Save',
				type: 'primary',
				style: 'bg-yellow-500 hover:bg-yellow-600',
				noDefineLabel: true,
				icon: 'check',
				position: 'right',
			},
		],
		defaultSteps: [
			{ title: 'Configuration' },
			{ title: 'Schedule Production' },
			{ title: 'Plan Quantity' },
		],
		editModeStepper: [
			{ title: 'Configuration' },
			{ title: 'Schedule Production' },
			{ title: 'Summary' },
		],
		footerRow: true,
		buttonContainerClass: 'w-full flex justify-between py-3 px-4',
	},
	buyerOrder: {
		heading: 'Multiple Buyer Order',
		emptyMessage:
			'Please select products to start multi buyer order creation',
		initialState: {
			fromStore: null,
			buyer: [],
			expectedDeliveryDate: new Date(),
			date: moment(new Date()).format('DD-MM-YYYY'),
		},
		showHeader: true,
		tableDataStatic: true,
		fields: [
			{
				id: 'fromStore',
				label: 'Sales From Store',
				type: 'select',
				required: true,
				dataKey: 'storeList',
				groupBy: 'type',
			},
			{
				id: 'buyer',
				label: 'Select Buyer',
				type: 'checkTreePicker',
				required: true,
				dataKey: 'buyerList',
			},
			{ id: 'date', label: 'Order Date', type: 'display' },
			{
				id: 'expectedDeliveryDate',
				label: 'Expected Delivery Date',
				type: 'date',
				required: true,
				shouldDisableDate: true,
			},
		],
		tableColumns: [
			{ name: 'S.No', id: 'S.No' },
			{ name: 'Item Name', id: 'Item Name' },
			{ name: 'SkuCode', id: 'SkuCode' },
		],
		tableCellKey: 'buyerOrder',
		tableConfig: {
			showGroupedHeaders: true,
			columnWidth: 135,
		},
		functionality: ['addProducts', 'paste'],
		buttons: [
			{
				id: 'multipleBuyerOrder',
				label: 'Multiple Buyer Order',
				type: 'primary',
				style: 'flex-1 bg-amber-300',
			},
			{
				id: 'multipleBuyerOrderAndPreviewProductionPlan',
				label: 'Multiple Buyer Order and Preview Production Plan',
				type: 'secondary',
				style: 'flex-1 hover:bg-amber-300 bg-amber-300',
			},
		],
	},
};
